<template>
  <div class="text-center" v-if="loading">
    <v-progress-circular indeterminate color="primary"></v-progress-circular>
  </div>
  <div v-else>
    <div v-if="current_org">
      <div>
        <v-layout column>
          <v-flex xs4 offset-xs8>
            <v-layout row justify-space-around>
              <v-btn rounded color="primary" class="text-capitalize" to="/organizations/new"
                v-if="$can('create organizations')">
                Ajouter
                <v-icon right>mdi-plus-circle-outline</v-icon>
              </v-btn>
              <v-btn rounded color="warning" class="text-capitalize" @click="editOrg(current_org.id)"
                v-if="$can('edit organizations')">
                Editer
                <v-icon right>mdi-pencil-outline</v-icon>
              </v-btn>
              <v-btn rounded color="error" class="text-capitalize" @click="isDeletingOrg()"
                v-if="$can('delete organizations')">
                Supprimer
                <v-icon right>mdi-trash-can-outline</v-icon>
              </v-btn>
            </v-layout>
          </v-flex>
        </v-layout>
      </div>

      <v-card class="mt-3 mb-3">
        <v-card-text>
          <v-container fluid grid-list-md>
            <v-layout row wrap align-center>
              <v-flex xs4>
                <span class="name-size">{{ current_org.name }}</span>
                <br>
                <span class="couleur-orange">{{ current_org.type }}</span>
              </v-flex>

              <v-flex xs3>
                <span class="">
                  <v-icon left>mdi-calendar</v-icon>{{ current_org.created_at | moment("D MMMM YYYY, HH:mm:ss") }}
                </span>
                <br>
                <v-chip pill color="green" text-color="white" class="mt-3">
                  <v-avatar left color="green darken-4">
                    {{ current_org.members_count }}
                  </v-avatar>
                  membres
                </v-chip>

              </v-flex>
            </v-layout>
          </v-container>

        </v-card-text>
      </v-card>

      <v-container fluid grid-list-sm>
        <v-layout row>
          <v-flex xs6 class="">
            <v-card class="">
              <v-card-text>
                <h4>PEA </h4> {{ current_org.pea }} <br>
                <h4 v-if="current_org.maillon">Maillon </h4> <span v-if="current_org.maillon">{{ current_org.maillon.name
                }}</span> <br>
                <!-- <h4 v-if="current_org.chain !==null">Chaine de valeur </h4>  {{ current_org.chain.name }} -->
              </v-card-text>
            </v-card>
          </v-flex>

          <v-flex xs6>
            <v-card class="">
              <v-card-text>
                <v-icon>mdi-map-marker</v-icon>
                {{ current_org.country ? current_org.country.name : '' }}, {{ current_org.department.name }},
                {{ current_org.municipality.name }}, {{ current_org.district.name }},
                {{ current_org.town.name }}, {{ current_org.place }}
                <br>
              </v-card-text>
            </v-card>

            <v-card class="mt-2">
              <v-card-text>
                <strong>Longitude </strong> {{ current_org.longitude }} <br>
                <strong>Latitude </strong> {{ current_org.latitude }} <br>
                <strong>Altitude </strong> {{ current_org.altitude }}
              </v-card-text>
            </v-card>
          </v-flex>

        </v-layout>
      </v-container>

      <v-card flat class="mt-5">
        <v-card-title>
          <h6 class="primary--text">Liste des acteurs de l'organisation</h6>
          <v-spacer></v-spacer>

          <v-btn rounded color="primary" class="text-capitalize">
            <export-excel :data="current_org.actors" name="Acteurs_organisation.xls" :export-fields="actors_fields">
              Exporter
              <v-icon right>mdi-share-outline</v-icon>
            </export-excel>
          </v-btn>
          <v-spacer></v-spacer>

          <v-text-field v-model="search" append-icon="mdi-magnify" label="Rechercher un acteur" single-line solo
            hide-details>
          </v-text-field>

        </v-card-title>
      </v-card>

      <v-data-table v-model="selected" :headers="headers" :items="current_org.actors" item-key="id" class="elevation-1"
        :search="search">

        <!-- <template v-slot:item.pivot.present="{ item }">
        <span v-if="item.pivot.present==1">Oui</span>
        <span v-else-if="item.pivot.present==0">Non</span>
      </template> -->

        <template v-slot:no-data>
          Aucun acteur associé à cette organisation
        </template>

      </v-data-table>
    </div>

    <v-layout row justify-center>
      <v-dialog v-model="dialog_deletion" max-width="290">
        <v-card>
          <v-card-title class="headline">Suppression</v-card-title>
          <v-card-text class="text-center">
            Etes-vous sûr de vouloir supprimer cette organisation ?
          </v-card-text>

          <v-card-actions>

            <v-btn color="orange" rounded @click="dialog_deletion = false">
              <span class="white-couleur">Non</span>
            </v-btn>
            <v-spacer></v-spacer>
            <v-btn color="success" rounded @click="delOrganization()">
              Oui
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-layout>


  </div>
</template>

<script>
import axios from 'axios'
import Permissions from '~/mixins/Permissions';

export default {
  name: 'organization-show',
  mixins: [Permissions],
  data: () => ({
    org_id: null,
    pagination: {
      sortBy: 'first_name'
    },
    selected: [],
    headers: [
      {
        text: 'Nom complet',
        align: 'center',
        value: 'first_name'
      },
      { text: 'Type', value: 'type', align: 'center' },
      { text: 'Langue', value: 'language', align: 'center' },
      { text: 'Instruction', value: 'instruction_level', align: 'center' },
      { text: 'Adresse', value: 'address', align: 'center' },
      { text: 'Contact', value: 'contact', align: 'center' },
    ],

    search: '',
    dialog_deletion: false,
    numeros: [],
    ids: [],
    actors_fields: {
      "Nom": "first_name",
      "Prenom": "last_name",
      "Sexe": "gender",
      "Age": "age",
      "Type": "type",
      "Contact": "contact",
      "Adresse": "address",
      "Langue": "language",
      "Niveau d'instruction": "instruction_level",
      "Fonction": "fonction",
    },
    current_org: [],
    loading: true
  }),

  created() {
    this.$checkPermission('view organizations')
    this.fetchUtils();
  },

  methods: {
    async fetchUtils() {
      this.loading = true;
      this.org_id = this.$route.params.Pid;
      const uri = '/api/organizations/' + this.org_id + '?filter[id]=' + this.org_id +
        '&include=country,department,municipality,district,town,chain,maillon,actors'
      const { data } = await axios.get(uri)
      this.current_org = data
      this.loading = false;
    },

    editOrg(id) {
      this.$router.push({ name: 'organizations.edit', params: { Pid: id } });
    },

    isDeletingOrg() {
      this.dialog_deletion = true;
    },

    delOrganization() {
      const uri = '/api/organizations/' + this.org_id;
      let route_obj = this.$router;

      axios.delete(uri)
        .then(response => {
          route_obj.push({ name: 'organizations.list', params: { org_deleted: true } });
        })
        .catch(err => { console.log("Organization deletion error ", err) });
    },

  }
};
</script>

<style scoped>
.name-size {
  font-size: 1.2em;
  /*font-weight: bold;*/
}

.couleur-orange {
  color: rgb(255, 152, 0);

  font-size: 1.2em;
}

.white-couleur {
  color: white;
}

.v-data-table-header {
  background-color: rgb(120, 185, 67);
  color: rgb(255, 255, 255);
}

.theme--light.v-table thead th {
  color: rgb(255, 255, 255);
}

.theme--light.v-datatable thead th.column.sortable.active {
  color: rgb(255, 255, 255);
}

.a-sans-style a {
  text-decoration: none;
}
</style>




// WEBPACK FOOTER //
// resources/assets/js/pages/organizations/show.vue